import { either, isEmpty, isNil, mergeDeepWithKey, sort } from 'ramda';
export const formatDate = (timestamp, locale = 'en-US', options = {}) => new Date(+timestamp).toLocaleDateString(locale, Object.assign({ hour: '2-digit', minute: '2-digit', month: 'short', day: 'numeric' }, options));
export const printTranscript = (printContentRef, iFrameId, onError) => {
    var _a;
    try {
        const content = (_a = printContentRef.current) === null || _a === void 0 ? void 0 : _a.innerHTML;
        const pri = document.getElementById(iFrameId).contentWindow;
        pri.document.open();
        pri.document.write(content);
        pri.document
            .querySelectorAll('.advisor-thumbnail')
            .forEach((img) => img.remove());
        pri.document.querySelectorAll('.attachment').forEach((img) => {
            img.style.width = '100px';
            img.style.height = '100px';
            img.style.objectFit = 'cover';
        });
        pri.document.querySelectorAll('svg').forEach((tick) => tick.remove());
        pri.document
            .querySelectorAll('.message')
            .forEach((customerMessage) => {
            const separator = pri.document.createElement('hr');
            customerMessage.after(separator);
        });
        pri.document.close();
        pri.focus();
        pri.print();
    }
    catch (e) {
        onError(e);
    }
};
export function createMarkup(message) {
    return { __html: message };
}
export function getRandomInt(min, max) {
    const newMin = Math.ceil(min);
    const newMax = Math.floor(max);
    return Math.floor(Math.random() * (newMax - newMin + 1)) + newMin;
}
export function mergeArrays(oldObjects, newObjects) {
    const mergeRightExceptTimestamp = (k, l, r) => k === 'persistedTimestamp' ? l : r;
    let updatedOldObjects = oldObjects.map(oldObj => newObjects.some(newObj => newObj.id === oldObj.id)
        ? mergeDeepWithKey(mergeRightExceptTimestamp, oldObj, newObjects.find(newObj => newObj.id === oldObj.id))
        : oldObj);
    const localMessages = newObjects.filter(obj => obj.local !== undefined && obj.local === true);
    updatedOldObjects = [...updatedOldObjects, ...localMessages];
    let filteredNewObjects = newObjects.filter(obj => !oldObjects.some(obj2 => obj.id === obj2.id));
    filteredNewObjects = filteredNewObjects.filter(obj => !obj.local);
    const newEvents = [...updatedOldObjects, ...filteredNewObjects];
    const sortedEvents = sort((a, b) => +a.persistedTimestamp - +b.persistedTimestamp, newEvents);
    return sortedEvents;
}
export const isNilOrEmpty = either(isNil, isEmpty);
//# sourceMappingURL=utils.js.map